import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { inject } from "@angular/core";
import { UserPreferenceService } from "./services/user-preference.service";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to 'redirect' which handles role-based landing page
    { path: '', pathMatch: 'full', redirectTo: 'redirect' },

    // Redirect signed-in user to 'redirect'
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'redirect' },


    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        resolve: {
            appearance: () => inject(UserPreferenceService).getAppearanceConfig(),
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // unauthorized-access route authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'unauthorized-access', loadChildren: () => import('app/modules/auth/unauthorized-access/unauthorized-access.routes') },
        ]
    },

    // Landing home page routes
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {
            layout: 'empty'
        },
        resolve: {
            appearance: () => inject(UserPreferenceService).getAppearanceConfig(),
        },
        children: [
            { path: 'redirect', loadChildren: () => import('app/modules/landing/redirect/redirect.routes') },
            { path: 'error-500', loadChildren: () => import('app/modules/error/error-500/error-500.routes') },

            {
                path: 'onboarding',
                resolve: {
                    initialData: initialDataResolver
                }, loadChildren: () => import('app/modules/landing/onboarding/onboarding.routes')
            },
        ]
    },

    // Home setting
    {
        path: 'home',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/home/home.routes') }
        ]
    },

    // Admin setting
    {
        path: 'admin',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/admin/admin.routes') }
        ]
    },

    // driver mgmt
    {
        path: 'driver-mgmt',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/driver-mgmt/driver-mgmt.routes') }
        ]
    },

    // trip mgmt
    {
        path: 'trip-mgmt',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/trip-mgmt/trip-mgmt.routes') }
        ]
    },

    // trips alias
    {
        path: 'trips',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/trip-mgmt/trip/trip.routes') }
        ]
    },

    // CRM
    {
        path: 'crm',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/crm/crm.routes') }
        ]
    },

    // Profile routes
    {
        path: 'profile',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'settings', loadChildren: () => import('app/modules/profile/settings/settings.routes') }
        ]
    },
    {
        path: 'help-center',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        loadChildren: () => import('app/modules/help-center/help-center.routes')
    },

];
